'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';
import { shimmerDataURL } from '@/data/siteImages';

type SmartImageProps = Omit<ImageProps, 'placeholder' | 'blurDataURL'> & {
  /** Fallback image used if the primary src fails to load. */
  fallbackSrc?: string;
};

/**
 * next/image wrapper with:
 *  - animated shimmer blur-up placeholder
 *  - graceful fallback on load error
 *  - sensible default sizes for responsive layouts
 */
export default function SmartImage({
  src,
  alt,
  fallbackSrc,
  sizes = '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  ...rest
}: SmartImageProps) {
  const [currentSrc, setCurrentSrc] = useState(src);

  return (
    <Image
      {...rest}
      src={currentSrc}
      alt={alt}
      sizes={sizes}
      placeholder="blur"
      blurDataURL={shimmerDataURL()}
      onError={() => {
        if (fallbackSrc && currentSrc !== fallbackSrc) setCurrentSrc(fallbackSrc);
      }}
    />
  );
}
